// extracted by mini-css-extract-plugin
export default {"search":"Search_search__Mw4zH","search_close":"Search_search_close__jpl1S"};